import { render, staticRenderFns } from "./marks.vue?vue&type=template&id=0f5c9184&scoped=true&"
import script from "./marks.vue?vue&type=script&lang=js&"
export * from "./marks.vue?vue&type=script&lang=js&"
import style0 from "./marks.vue?vue&type=style&index=0&id=0f5c9184&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c9184",
  null
  
)

export default component.exports